import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var withText = function(TextComponent) {
    return function(param) {
        var children = param.children, id = param.id;
        if (!children) {
            return null;
        }
        return /*#__PURE__*/ _jsx(TextComponent, {
            id: id,
            children: children
        });
    };
};
export { withText };
